import GoogleMap from "../map/google-map-operations-details";
// import GoogleMap from "../map/google-map-component";
import { useSelector } from "react-redux";
import { AppState } from "../../../../store/store";

const OperationsDetailsMap = (props:any) => {
    const ResizeStoreToSetHeight = useSelector((state: AppState) => state.AuraCameraCommon.setMapHeightPanel);
   
    return (
        <>
            <GoogleMap lati={-31.563910} lon={147.154312} data={props} height={ResizeStoreToSetHeight}/>
        </>
    );
}

export default OperationsDetailsMap;